<template>
   <section class="ws-orgs__item-content">
      <div class="ws-orgs__item-curators" v-if="curators.length">
        <span v-text="$t('Кураторы:')"></span>
        <span>&nbsp;</span>
        <b-dropdown
          class="ws-participants__dropdown"
          aria-role="list"
          position="is-top-right">
                  <span
                    class="is-hoverable"
                    slot="trigger"
                    role="button">
                      <span v-text="$t('назначено')"></span>
                      <span>&nbsp;</span>
                      <span v-text="curators.length"></span>
                  </span>
          <b-dropdown-item custom v-for="curator in curators" :key="curator.id" aria-role="listitem">
            <div class="media" v-if="curator.user_info">
              <div class="media-left">
                <figure class="image is-48x48">
                  <ws-avatar :id="curator.user_info.guid"
                             :name="`${ curator.user_info.first.display } ${curator.user_info.last.display}`"
                             sizeType="Small"
                             :size="48" />
                </figure>
              </div>
              <div class="media-content" v-if="curator.user_info">
                <strong>{{ curator.user_info.last.display }}</strong><br>
                <span>{{ curator.user_info.first.display }}</span><br>
                <span>{{ curator.user_info.email }}</span>
                <br>
                <span>{{ getPhoneNumber(curator) }}</span>
              </div>
              <div v-else v-text="curator.guid"></div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </section>
</template>

<script>
import getPhoneNumber from '@/utils/getPhoneNumber'
export default {
  name: 'WsCuratorList',
  props: {
    curators: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getPhoneNumber

  }

}
</script>

<style lang="scss" scoped>
.ws-orgs__item-content {
  padding: 0;
}
.ws-list-view__item.is-selected {
  .has-text-primary {
    color: #0231af
  }
}
</style>
